import { ResourceAutoAssignmentPrioritizationValues } from '@shared/resource/enums';

export const reservationsPageViewList: Array<{ name: string; value: string }> = [
  {
    name: 'List View',
    value: 'list',
  },
  {
    name: 'Timeline View',
    value: 'timeline',
  },
];

export const resourceAutoAssignmentPrioritizationMethods = [
  {
    name: 'Random',
    value: ResourceAutoAssignmentPrioritizationValues.Random,
  },
  {
    name: 'Alphabetical',
    value: ResourceAutoAssignmentPrioritizationValues.Alphabetical,
  },
  {
    name: 'Resources sort order',
    value: ResourceAutoAssignmentPrioritizationValues.ResourcesSortOrder,
  },
  {
    name: 'Round Robin',
    value: ResourceAutoAssignmentPrioritizationValues.RoundRobin,
  },
];
